<template>
  <router-view />
</template>
<script>
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};
</script>
<style lang="scss">
.el-overlay {
  z-index: 99999 !important;
}
.el-popper {
  z-index: 9999999999999999999 !important;
}
* {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
::-webkit-scrollbar {
  width: 5px;
  height: 7px;
}

::-webkit-scrollbar-thumb {
  background: rgba(144, 147, 153, 0.3);
  border-radius: 20px;
}
.el-drawer__header {
  padding: 12px 20px !important;
  margin-bottom: 0 !important;
  background-color: #212227;
  color: #fff !important;
  font-size: 14px;
  border-bottom: 1px solid rgba(151, 151, 151, 0.33);
  &::before {
    content: "";
    width: 0.3125rem;
    height: 1.25rem;
    background-color: #3b35ff;
    position: absolute;
    left: 0;
    top: 0.8rem;
  }
  &::after {
    content: "";
    width: 0;
    height: 0;
    border-left: 0.625rem solid #3b35ff;
    border-top: 0.625rem solid transparent;
    border-bottom: 0.625rem solid transparent;
    position: absolute;
    left: 0.3125rem;
    top: 0.8rem;
  }
}
.el-date-editor .el-range-input {
  color: #dedede !important;
}
.el-drawer__body {
  background-color: #212227;
  color: #fff;
}
.selectInput .el-select .el-input__wrapper {
  // border-right: 0 !important;
  border-radius: 4px 0 0 4px;
}
.el-select {
  --el-select-input-focus-border-color: #ffffff00 !important;
}
.el-loading-mask {
  background-color: #7e7d7d93 !important;
}
// .el-loading-mask .circular {
//   display: none !important;
// }
// .el-loading-spinner {
//   background: url('//cdn.hsuanyuen.com/Fe-public/qc-file/loading.gif') no-repeat;
//   background-size: 90px;
//   background-position: center;
//   width: 100%;
//   height: 100%;
//   position: relative;
//   top: 0 !important;
// }
.el-dialog {
  --el-dialog-bg-color: #212227 !important;
  --el-dialog-text-color: #fff !important;
  --el-dialog-margin-top: 12vh !important;
  .el-dialog__header {
    color: #ffffffb1 !important;
    border-bottom: 1px solid rgba(151, 151, 151, 0.33);
    width: 93%;
    &::before {
      content: "";
      width: 0.3125rem;
      height: 1.25rem;
      background-color: #3b35ff;
      position: absolute;
      left: 0;
      top: 1.38rem;
    }
    &::after {
      content: "";
      width: 0;
      height: 0;
      border-left: 0.625rem solid #3b35ff;
      border-top: 0.625rem solid transparent;
      border-bottom: 0.625rem solid transparent;
      position: absolute;
      left: 0.3125rem;
      top: 1.38rem;
    }
    .el-dialog__title {
      color: #ffffff !important;
      font-size: 1rem;
    }
    .el-dialog__close {
      color: #ffffff !important;
    }
  }
  .el-form-item--default .el-form-item__label {
    color: #ffffffd5;
  }
}
.el-message-box {
  background-color: #212227 !important;
  border: 0 !important;
  --el-messagebox-title-color: #fff !important;
  --el-messagebox-content-color: #fff !important;
}
.el-overlay {
  background: rgba(255, 255, 255, 0.25) !important;
}
.el-pagination.is-background .btn-next.is-active,
.el-pagination.is-background .btn-prev.is-active,
.el-pagination.is-background .el-pager li.is-active {
  background-color: var(--el-color-primary) !important;
  color: var(--el-color-white) !important;
}
.el-pagination.is-background .el-pager li {
  background-color: #f0f2f500 !important;
  color: #ffffff7e !important;
}
.el-pagination.is-background .btn-next.is-disabled,
.el-pagination.is-background .btn-next:disabled,
.el-pagination.is-background .btn-prev.is-disabled,
.el-pagination.is-background .btn-prev:disabled,
.el-pagination.is-background .el-pager li.is-disabled,
.el-pagination.is-background .el-pager li:disabled {
  background-color: #f5f7fa30 !important;
}
.el-pagination.is-background .btn-prev {
  background-color: #f0f2f500 !important;
  color: #ffffff7e !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li:nth-of-type(-1) {
  background-color: #f0f2f500 !important;
  color: #ffffff7e !important;
}
.el-table {
  --el-table-text-color: #ffffff !important;
  --el-table-header-text-color: #ffffff !important;
  --el-table-header-bg-color: #1514228c !important;
  --el-table-bg-color: #ffffff00 !important;
  --el-table-tr-bg-color: #ffffff00 !important;
  --el-table-row-hover-bg-color: #ffffff0e !important;
  --el-table-border-color: #ffffff00 !important;
  --el-table-border: 0.5px solid #ebeef53b !important;
  font-size: 0.875rem !important;
  --el-table-fixed-left-column: inset 10px 0 10px -10px rgb(0 0 0 / 0.6) !important;
  & .el-table__cell {
    font-size: 0.875rem;
    // z-index: 1000 !important;
  }
}
.el-radio-button .el-radio-button__inner {
      height: 32px !important;
      padding: 0 23px;
      display: flex;
    align-items: center;
      background-color: #3c35ff00 !important;
      border: px solid rgba(255, 255, 255, 0.2039215686) !important;
      color: rgb(168, 171, 178)  !important;
      font-size: 12px !important;
    }
    .el-radio-button__inner {
      border: px solid rgba(255, 255, 255, 0.2039215686) !important;
    }
.el-radio-button__original-radio:checked + .el-radio-button__inner
       {
      background-color: #3988FF !important;
      border-color: #3988FF !important;
      color: #ffffff !important;
      font-size: 12px !important;
    }
.el-table__inner-wrapper {
  height: 100% !important;
}
.el-radio-group .el-radio-button__inner {
  font-size: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.2039215686) !important;
}
.el-table td.el-table__cell div {
  font-size: 14px;
}
.el-input__wrapper {
  background-color: transparent !important;
  border: 1px solid #ffffff34 !important;
  box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color))
    inset !important;
  color: #ffffff !important;
  .el-input__inner {
    font-size: 12px !important;
    color: #DEDEDF !important;
  }
}
.el-input-group--append > .el-input__wrapper {
  border-right: 0 !important;
}
.el-input-group__append,
.el-input-group__prepend {
  font-size: 12px !important;
  background-color: #3b35ff !important;
  box-shadow: 0 0px 0 0 var(--el-input-border-color) inset,
    0 0px 0 0 var(--el-input-border-color) inset,
    0px 0 0 0 var(--el-input-border-color) inset !important;
  color: #ffffff !important;
  .el-input__wrapper {
    border-right: 0 !important;
  }
}
.el-button--primary {
  --el-button-bg-color: rgba(57, 136, 255, 1) !important;
  --el-button-border-color: rgba(57, 136, 255, 1) !important;
}

.el-button {
  --el-button-hover-text-color: #ffffff !important;
  --el-button-hover-bg-color: var(--el-button-bg-color) !important;
  font-size: 12px !important;
}
.el-button--info {
  --el-button-bg-color: #ffffff00 !important;
  --el-button-border-color: #504f58 !important;
  --el-button-hover-text-color: #DEDEDF !important;
}
.el-table__body-wrapper .el-table__cell {
  padding: 8px 0;
  font-size: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}
.el-tooltip__popper{ max-width:50% !important}
.el-popper{ max-width:35%!important; }
.el-table__body-wrapper tr:hover {
  .el-table__cell {
    color: #fff !important;
  font-weight: 600 ;
  p {
    color: #fff !important;
  }
  span {
    color: #fff !important;
  }
  }
  // transform: scale(1.5);
}
.el-table__body-wrapper tr {
  color: rgb(255 255 255 / 70%);
  // transform: scale(1.5);
}
.el-checkbox__input.is-checked+.el-checkbox__label {
  color: rgba(57, 136, 255, 1) !important;
  
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: rgba(57, 136, 255, 1) !important;
    border-color: rgba(57, 136, 255, 1) !important;
}
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: rgba(57, 136, 255, 1) !important;
    border-color: rgba(57, 136, 255, 1) !important;
}
  .el-input {
    height: 32px !important;
    line-height: 32px !important;
    color: #DEDEDF !important;
  }
  .el-date-editor.el-input, .el-date-editor.el-input__wrapper {
    height: 32px !important;
    color: #DEDEDF !important;
  }
  .el-select .el-input {
    height: 32px !important;
    line-height: 32px !important;
    color: #DEDEDF !important;
  }
  .el-input__wrapper .el-input__inner {
    font-size: 12px !important;
    color: #DEDEDF !important;
}
input::-webkit-input-placeholder {
color: #DEDEDF !important;
font-size: 12px;
}
</style>
